import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Applicant } from 'src/app/models/applicant';
import { ApplicantSelected } from 'src/app/models/applicantSelected';
import { GeneralInfo } from 'src/app/models/generalInfo';
import { NavigationParameters } from 'src/app/models/navigationParameters';
import { Parameters } from 'src/app/models/parameters';
import { PortalLookups } from 'src/app/models/portalLookups';
import { PortalParameters } from 'src/app/models/portalParameters';
import { Waitlists } from 'src/app/models/waitlists';
import { ConfirmationMessageService } from 'src/app/services/confirm-message.service';
import { MessageService } from 'src/app/services/message.service';
import { PopupMessageService } from 'src/app/services/popup.message.service';
import { StaffDashboardService } from 'src/app/services/staff-dashboard.service';
import { StaffPortalService } from 'src/app/services/staff-portal.service';
import { WaitlistPortalService } from 'src/app/services/waitlist-portal.service';
import { WaitlistService } from 'src/app/services/waitlist.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-staff-dashboard',
  templateUrl: './staff-dashboard.component.html',
  styleUrls: ['./staff-dashboard.component.scss']
})
export class StaffDashboardComponent {
  applicant:Applicant = new Applicant();
  selectedApplicants:ApplicantSelected[] = [];
  allSelectedApplicants:ApplicantSelected[] = [];
  filteredSelectedApplicants:ApplicantSelected[] = [];
  selectedApplicant:ApplicantSelected = new ApplicantSelected();
  waitlists:Waitlists[] = [];
  generalInfo:GeneralInfo;
  params:Parameters = new Parameters();
  portalParams:PortalParameters = new PortalParameters();
  navigationParams:NavigationParameters = new NavigationParameters();
  isMobile:boolean = false;
  @ViewChild("content",{static:true}) content:ElementRef;
  applicantStatuses:PortalLookups[] = [];
  formInvalid:boolean = false;
  infoTextTitle: string;
  infoTextDescription:string;
  updateParam:string;
  imgFolder: string = environment.imgFolder;
  currentPage: number = 1;
  itemsPerPage: number = 20;
  totalItems: number = 0;
  searchText: string = "";  
  selectedDates: Date[] = [];

constructor(
  private spinnerService: NgxSpinnerService,
  private waitlistService:WaitlistService,
  private waitlistPortalService:WaitlistPortalService,
  private staffDashboardService:StaffDashboardService,
  private staffPortalService:StaffPortalService,
  private msg:MessageService,
  private router:Router,
  private confirmationService: ConfirmationMessageService,
  private popupMessageService:PopupMessageService,
  private modalService: NgbModal
) {
  this.isMobile = window.innerWidth < 768;
}


  ngOnInit(){

      this.spinnerService.show();
      this.navigationParams = JSON.parse(localStorage.getItem('navigationParams'));

      this.portalParams.category = "Waiting Lists";
      this.waitlistService.getWaitlistsByWLTypeCategory(this.portalParams)
      .subscribe(w=>{
          this.waitlists = w.filter(w => !w.name.includes("Referral"));
          this.getSelectedApplicantsByWaitlist(w[0]);
      }, (err) => {
          this.spinnerService.hide();            
          this.msg.showError(err, "Loading Error");
      })

      this.waitlistPortalService.getPortalLookups("ApplicantStatus").then((data) => {
          this.applicantStatuses = data;
      }).catch((error) => { this.spinnerService.hide(); });

      this.spinnerService.hide();
  }
      
  search(){
    
    if (this.searchText.length > 0)
      this.filteredSelectedApplicants = this.allSelectedApplicants.filter(p => p.pCode?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.firstName?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.lastName?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.mailingAddress?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.apt?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.city?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.state?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.zipCode?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.tenantStatus?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.preferences?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
        || p.otherTCodes?.toUpperCase().includes(this.searchText.toLocaleUpperCase())
      );
    else
      this.filteredSelectedApplicants = this.allSelectedApplicants;

      this.selectedApplicants = this.filteredSelectedApplicants.filter((a, i) => i >= (this.currentPage - 1) * this.itemsPerPage && i < (this.currentPage) * this.itemsPerPage);
      this.totalItems = this.filteredSelectedApplicants.length;
  }


  getSelectedApplicantsByWaitlist(w:Waitlists){
    if (w.yardiDB.toUpperCase() == "HCV")
    {
      this.params.waitList = w.name;
      this.staffDashboardService.getSelectedApplicantsByWaitlistHCV(this.params)
      .subscribe((a) =>{
        this.selectedApplicants = a;

        this.allSelectedApplicants = this.filteredSelectedApplicants = a;
        this.selectedApplicants = this.filteredSelectedApplicants.filter((p, i) => i >= (this.currentPage - 1) * this.itemsPerPage && i < (this.currentPage) * this.itemsPerPage)
        this.totalItems = a.length;

        this.selectedDates = [];
        this.selectedDates.push(null)
        a.forEach(selectedDate => {
          if (!this.selectedDates.includes(selectedDate.dateSelected)) {
              this.selectedDates.push(selectedDate.dateSelected);
          }
        });

      })
    }
    if (w.yardiDB.toUpperCase() == "CNV")
    {
      this.params.waitList = w.name;
      this.staffDashboardService.getSelectedApplicantsByWaitlistCNV(this.params)
      .subscribe((a) =>{
        this.selectedApplicants = a;

        this.allSelectedApplicants = this.filteredSelectedApplicants = a;
        this.selectedApplicants = this.filteredSelectedApplicants.filter((p, i) => i >= (this.currentPage - 1) * this.itemsPerPage && i < (this.currentPage) * this.itemsPerPage)
        this.totalItems = a.length;

        this.selectedDates = [];
        this.selectedDates.push(null)
        a.forEach(selectedDate => {
          if (!this.selectedDates.includes(selectedDate.dateSelected)) {
              this.selectedDates.push(selectedDate.dateSelected);
          }
        });

      })
    }
  }

  changeSelectedApplicantsByWaitlist(event:any){
    this.spinnerService.show();
    let waitlist:Waitlists = this.waitlists.filter(w => w.name == event.target.value)[0];
    this.getSelectedApplicantsByWaitlist(waitlist);
    this.spinnerService.hide();
  }


  changeSelectedApplicantsByDateSelected(event:any){
    this.spinnerService.show();
    
    if (event.target.value != null && event.target.value.length > 4)
      this.filteredSelectedApplicants = this.allSelectedApplicants.filter(p => p.dateSelected == event.target.value);
    else
      this.filteredSelectedApplicants = this.allSelectedApplicants;
      
    this.selectedApplicants = this.filteredSelectedApplicants.filter((p, i) => i >= (this.currentPage - 1) * this.itemsPerPage && i < (this.currentPage) * this.itemsPerPage)
    this.totalItems = this.filteredSelectedApplicants.length;
    this.currentPage = 1;

    this.spinnerService.hide();
  }


  goToApplicantDashboard(pCode:string){

    this.navigationParams = JSON.parse(localStorage.getItem('navigationParams')) ?? new NavigationParameters();
    if(pCode.substring(0,2) == 't5')
      this.navigationParams.cnvTCode = pCode;

    if(pCode.substring(0,2) == 't0')
      this.navigationParams.hcvTCode = pCode;
    this.navigationParams.userRole = "Staff";
    
    localStorage.setItem('navigationParams', JSON.stringify(this.navigationParams));
    this.params.applicantCode = pCode;
    this.staffPortalService.setupSelectedApplicant(this.params);    

    setTimeout(() => {
      this.router.navigate(['/applicantDashboard']);  
    }, 3000);
    
  }


  pageChangeEvent(event: number){
    this.currentPage = event;
    this.selectedApplicants = this.filteredSelectedApplicants.filter((p, i) => i >= (this.currentPage - 1) * this.itemsPerPage && i < (this.currentPage) * this.itemsPerPage)
  }


  popupClick(infoText:string){
      let statusDescription = this.applicantStatuses.find(s => s.description.substring(0, 12).includes(infoText)).description.replace(infoText + "-", "");
      this.popupMessageService.show("Waiting List Status - " + infoText, statusDescription, true, "md");
  }


}